export const MAX_CAMPAIGN_RENAMES = 25;
export type CampaignRenameItem = { campaignId: string; newName: string };
export type CampaignRenameResult = CampaignRenameItem & {
  accountId: string;
  outcome: "acknowledged" | "rejected" | "ambiguous" | "not_sent";
  message: string;
};
export function campaignRenameName(value: unknown): string {
  if (typeof value !== "string" || !value.trim() || value.trim().length > 400)
    throw new Error("Campaign name must be non-empty text, up to 400 characters.");
  return value.trim();
}
export function campaignRenameId(value: unknown, account = false): string {
  const text = typeof value === "string" ? value.trim() : "";
  const normalized = account ? text.replace(/^act_/i, "") : text;
  if (!/^\d{1,40}$/.test(normalized)) throw new Error(`Invalid ${account ? "account" : "campaign"} ID.`);
  return normalized;
}
export function campaignRenameItems(value: unknown): CampaignRenameItem[] {
  if (!Array.isArray(value) || !value.length || value.length > MAX_CAMPAIGN_RENAMES)
    throw new Error(`Choose between 1 and ${MAX_CAMPAIGN_RENAMES} campaigns.`);
  const items = value.map(item => ({ campaignId: campaignRenameId(item?.campaignId), newName: campaignRenameName(item?.newName) }));
  if (new Set(items.map(item => item.campaignId)).size !== items.length) throw new Error("Each campaign must appear only once.");
  return items;
}
